<template>
  <div style="position:relative;">
    <el-tooltip :ref="ref" :id="id" class="zycTooltipText" effect="dark" :content="title" placement="top" :disabled="disabled">
      <span> {{ title }}</span>
    </el-tooltip>
    <div :ref="ref1"></div>
  </div>
</template>
<script>
  export default {
    name: 'zycTooltipText',
    props: {
      title: {
        type: String,
        required: false
      }
    },
    watch: {
      'title': {
        handler(obj) {
          this.$nextTick(() => {
            this.init()
          })
        }
      }
    },
    data() {
      return {
        disabled: true,
        id: Math.random().toString(36).slice(2),
        ref: Math.random().toString(36).slice(2),
        ref1: Math.random().toString(36).slice(2),
      }
    },
    mounted() {
      this.$refs[this.ref1].appendChild(this.$refs[this.ref].popperVM.$el)
      this.init()
    },
    methods: {
      init: function () {
        const el = document.getElementById(this.id)
        const elComputed = document.defaultView.getComputedStyle(el, '')
        const padding =
          parseInt(elComputed.paddingLeft.replace('px', '')) +
          parseInt(elComputed.paddingRight.replace('px', ''))

        const range = document.createRange()
        range.setStart(el, 0)
        range.setEnd(el, el.childNodes.length)
        const rangeWidth = range.getBoundingClientRect().width
        if (rangeWidth + padding > el.offsetWidth) {
          this.disabled = false
        } else {
          this.disabled = true
        }
      }
    }
  }
</script>

<style scoped>
  .zycTooltipText {
    display:inline-block;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 1;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/zyc/other/tooltipText.vue